import React from "react";
import PageShell from "../../components/shared/page-shell/page-shell.tsx";
import { useActiveProbationCycle } from "../../components/features/assessment/hooks/index.ts";
import PerformanceV2 from "../../../Pages/Employee/PerformanceV2.jsx";
import { PageProps } from "../../types/page.ts";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/index.ts";
import { useState } from "react";
import { ProbationAssessmentTab } from "../../components/features/assessment/tabs/probation-assessment-tab.tsx";
import { Spinner } from "../../components/ui/spinner/spinner.tsx";
import { useUser } from "../../lib/rbac/useUser.ts";
import { isSqeLabsEmployeeType } from "../../hooks/use-logged-in-employee.ts";

export const TAB_PERFORMANCE = "performance";
export const TAB_PROBATION = "probation";

export default function AssessmentPage({ title, description }: PageProps) {
  const { cycle, loading } = useActiveProbationCycle();
  const [activeTab, setActiveTab] = useState<string>(TAB_PROBATION);
  const user = useUser();
  const isSqeEmployee = isSqeLabsEmployeeType(user?.empType);

  if (loading) {
    return (
      <PageShell>
        <Spinner variant="overlay"/>
      </PageShell>
    );
  }

  if (cycle) {
    return <PageShell>
      <Tabs value={isSqeEmployee ? TAB_PROBATION : activeTab} onValueChange={setActiveTab}>
        <TabsList>
          {!isSqeEmployee && <TabsTrigger value={TAB_PERFORMANCE}>Performance</TabsTrigger>}
          <TabsTrigger value={TAB_PROBATION}>Probation</TabsTrigger>
        </TabsList>

        {!isSqeEmployee && (
          <TabsContent value={TAB_PERFORMANCE}>
            <PerformanceV2 />
          </TabsContent>
        )}

        <TabsContent value={TAB_PROBATION}>
          <ProbationAssessmentTab cycleId={cycle.cycleId} />
        </TabsContent>
      </Tabs>
    </PageShell>
  }

  if (isSqeEmployee) {
    return <PageShell>No active probation assessment is available.</PageShell>;
  }

  return (
    <PageShell>
      <PerformanceV2 />
    </PageShell>
  );
}
